<template>
  <div>
    <h3 class="page-title">消费详情</h3>
    <div class="detail-page-content">
      <div class="order-detail-header">
        <h4>{{$route.query.name.split('(')[0]}}</h4>
        <div class="order-detail-time">{{info.transactionDate}}</div>
      </div>
      <ul class="order-item">
        <li v-for="(item,index) in info.soldItem" :key="index">
          <h5>{{item.alternateDescription}}</h5>
          <div class="order-item-num">X{{item.quantity}}</div>
          <div class="order-item-price">￥{{item.salesStandIncTax}}</div>
        </li>
      </ul>
      <div class="soldTotal">
        <span>￥{{info.orderAmount}}</span>总计消费
      </div>
      <div class="order-detail-bottom">
        <p>本次消费总获得{{info.tierPoints}}<icon name="star" class="star-icon1"/>等级星星</p>
        <p>{{info.rewardPoints}}<icon name="star" class="star-icon2"/>基础好礼星星</p>
        <p><span class="star-icon3">+{{info.fastTrackPoints}}</span><icon name="star" class="star-icon3"/>奖励好礼星星</p>
      </div>
      <div class="order-detail-explian">
        <icon name="star" class="star-icon3"/>{{info.description.zh}}
      </div>
    </div>
  </div>
</template>
<script>
import {getOrderDetail} from '@/api'
import { Icon } from 'vant';
export default {
  data(){
    return{
      info:{}
    }
  },
  components:{
    Icon
  },
  async mounted(){
    const res = await getOrderDetail(this.$route.query.id);
    if(res.code === 0){
      this.info = res.data.transaction
    }
  }
}
</script>
<style lang="scss" scoped>
.page-title {
  font-size: 36px;
  padding: 30px 30px 20px;
  margin: 0;
  color: #303133;
  font-weight: 700;
}

.detail-page-content {
  min-height: calc(100vh - 100px);
  padding: 0 30px 40px;
  background: linear-gradient(180deg, #f5f7fa 0%, #e4e7ed 100%);
}

.order-detail-header {
  background: #fff;
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);

  h4 {
    font-size: 32px;
    font-weight: 600;
    margin: 0 0 16px;
    color: #303133;
    display: flex;
    align-items: center;
  }

  .order-detail-time {
    font-size: 24px;
    color: #909399;
  }
}

.order-item {
  background: #fff;
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);

  li {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px solid #f2f6fc;

    &:last-child {
      border-bottom: none;
    }

    h5 {
      padding: 0;
      margin: 0;
      flex: 1;
      font-size: 28px;
      font-weight: 500;
      color: #303133;
    }

    .order-item-num {
      width: 80px;
      text-align: center;
      color: #909399;
      font-size: 24px;
    }

    .order-item-price {
      width: 120px;
      text-align: right;
      font-size: 28px;
      color: #303133;
      font-weight: 600;
    }
  }
}

.soldTotal {
  background: #fff;
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 20px;
  font-size: 32px;
  font-weight: 700;
  color: #303133;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    color: #e6a23c;
    font-size: 36px;
  }
}

.order-detail-bottom {
  background: #fff;
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 20px;
  text-align: right;
  font-size: 26px;
  font-weight: 500;
  color: #606266;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);

  p {
    margin: 16px 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

.star-icon1 {
  color: #c5a45e;
  margin-left: 8px;
}

.star-icon2 {
  color: #e4496a;
  margin-left: 8px;
}

.star-icon3 {
  color: #dfc38c;
  margin-left: 8px;
}

.order-detail-explian {
  background: linear-gradient(135deg, #fff9e6, #fff3cd);
  border-radius: 20px;
  padding: 30px;
  text-align: center;
  font-size: 26px;
  color: #8b6914;
  box-shadow: 0 4px 16px rgba(139, 105, 20, 0.1);
}
</style>